import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { useRecentsContext } from "@/components/Product/ProductSlider/sources/recents/context/recents.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const DeleteHistoryButton = ({ className }: Props) => {
    const { t } = useGranite();

    const { deleteRecentsHistory } = useRecentsContext();

    const handleOnClick = (event: MouseEvent) => {
        event.preventDefault();

        deleteRecentsHistory();
    };

    return (
        <Button
            color={"link"}
            onClick={handleOnClick}
            className={cn("tw:p-0", className)}
        >
            {t("productSlider.link.deleteHistory")}
        </Button>
    );
};
